import {
  NumberInput,
  NumberInputProps,
} from '@zorro/design-system/v2/NumberInput';
import { ForwardedRef, forwardRef } from 'react';

export type ICurrencyInput = NumberInputProps;

export const ZorroCurrencyInput = forwardRef(
  (
    {
      thousandSeparator = ',',
      prefix = '$',
      decimalScale = 0,
      fixedDecimalScale = true,
      ...props
    }: ICurrencyInput,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <NumberInput
        thousandSeparator={thousandSeparator}
        fixedDecimalScale={fixedDecimalScale}
        prefix={prefix}
        decimalScale={decimalScale}
        ref={ref}
        {...props}
      />
    );
  }
);

ZorroCurrencyInput.displayName = 'CurrencyInput';
